import React from "react";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import { useGameResearch } from "@seabrookstudios/pitch2table";
import { useGameIdFromRoute } from "../WithGameIdFromRoute";
import { useMakeListAndDetail, useMakeListBuilder } from "../../core/useMakeLayout";
import { NoItemsFound } from "../../publisher/NoItemsFound";
import OpenInNewOutlined from "@mui/icons-material/OpenInNewOutlined";
import { ExternalLink } from "../../styleguide/AppLink";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import Alert from "@mui/material/Alert";

const NoGameResearch = () => <NoItemsFound>No game research found.</NoItemsFound>;

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").GameResearchScore} props.item
 */
const GameResearchListEntry = ({ item }) => (
  <ListItem divider>
    <ListItemText primary={item.name} />
    <Stack direction="row" spacing={1}>
      <ExternalLink href={`https://boardgamegeek.com/boardgame/${item.bggId}`}>
        <ListItemIcon>
          <ListItemButton>
            <OpenInNewOutlined />
          </ListItemButton>
        </ListItemIcon>
      </ExternalLink>
    </Stack>
  </ListItem>
);

const Header = () => (
  <Alert severity="info">
    We&apos;ve matched the following games based on pitch information you&apos;ve provided. We don&apos;t search BGG, so
    do those search as well. These are games whose description matches has a partial match to your game in how it&apos;s
    described. Think of this as a vibe match. Links go directly to publisher&apos;s website and BGG where available.
    Content may not longer be available on these sources.
  </Alert>
);

export const GameResearchListAndDetail = () => {
  const gameId = useGameIdFromRoute();

  const useWrappedQuery = () => useGameResearch(gameId);

  const useMakeList = useMakeListBuilder(
    GameResearchListEntry,
    (item) => `${item.publisherName}-${item.gameName}`,
    "Game Research",
    NoGameResearch,
    undefined,
    Header
  );

  const ListAndDetail = useMakeListAndDetail(useWrappedQuery, [], "game-research", useMakeList);

  return <ListAndDetail />;
};
